import React, { useState } from 'react';
import { Card } from 'pokemon-tcg-sdk-typescript';
import { useNavigate } from 'react-router-dom';
import { slugify } from '../utils/slugify';
import CardImage from './CardImage';
import { logFailedImage } from '../lib/imageLogger';

interface SearchResultsProps {
  cards: Card[];
  loading: boolean;
}

export default function SearchResults({ cards, loading }: SearchResultsProps) {
  const navigate = useNavigate();

  if (loading) {
    return (
      <div className="flex justify-center py-8">
        <div className="animate-spin rounded-full h-8 w-8 border-2 border-white border-t-transparent"></div>
      </div>
    );
  }

  if (cards.length === 0) {
    return (
      <div className="text-center py-8 text-white/60">
        No cards found
      </div>
    );
  }

  const handleCardClick = (card: Card) => {
    const seriesSlug = slugify(card.set.series);
    const setSlug = slugify(card.set.name);
    const cardSlug = `${slugify(card.name)}-${card.number}`;
    // Pass state to indicate this navigation came from search
    navigate(`/${seriesSlug}/${setSlug}/${cardSlug}/`, {
      state: { fromSearch: true }
    });
  };

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4 py-8">
      {cards.map(card => (
        <div
          key={card.id}
          className="group relative bg-white/5 border border-white/10 rounded-lg overflow-hidden cursor-pointer hover:ring-2 hover:ring-white/25 transition-all"
          onClick={() => handleCardClick(card)}
        >
          <div className="relative aspect-[2.5/3.5]">
            <CardImage
              src={card.images?.small || `https://yjzlookljahphgxcwpnv.supabase.co/storage/v1/object/public/pokemon-images/pokemon_cards/${card.id}_small.png`}
              alt={card.name}
              cardId={card.id}
              className="absolute inset-0 w-full h-full object-cover"
              width={245}
              quality={75}
            />
            <div className="absolute bottom-0 inset-x-0 bg-black/90 backdrop-blur-sm p-2">
              <p className="text-sm text-white font-medium truncate">{card.name}</p>
              <p className="text-xs text-white/60">{card.set.name}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}